import { pathName } from '../pathName';
import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface AuthServiceInterface {
  reqBody?: ReqBodyType;
  token: string;
  specificToken?: string;
}

class AuthService {
  private readonly httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient(pathName);
  }

  auth = async({
    reqBody,
    token,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      path: '/login',
      reqBody,
      token,
      isLogin: true,
    });
  };

  changePassword = async({
    reqBody,
    token,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      path: '/update-password',
      reqBody,
      token,
    });
  };

  resetPassword = async({
    reqBody,
    token,
  }: AuthServiceInterface) => {
    return this.httpClient.post({
      path: '/reset-password',
      reqBody,
      token,
    });
  };
}

export default new AuthService();
